var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWxPuzzleusdnTci(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 330,
    viewBox: "0 0 330 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.529 197.602C211.042 186.945 173.803 165.459 173.803 165.459C173.803 165.459 247.926 122.623 284.871 101.281L284.944 101.327L285.028 101.379C266.768 133.001 229.529 197.602 229.529 197.602Z",
    fill: "#E04A50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7031 91.9186C43.6311 88.4381 49.8752 84.856 55.3278 81.7188C55.2756 129.137 55.2234 176.558 55.1715 223.979C49.5041 227.252 37.7031 233.799 37.7031 233.799V91.9186Z",
    fill: "#5980E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1355 76.6003C78.6659 68.2067 108.189 51.4007 108.189 51.4007C108.183 98.7513 108.177 146.105 108.171 193.456C93.8033 201.739 63.9792 218.72 63.9792 218.72C64.0344 169.29 64.0803 127.285 64.1355 76.6003Z",
    fill: "#7075E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117 46.0767C131.53 37.6892 146.061 29.3016 160.591 20.9142C160.643 68.2188 160.695 115.523 160.747 162.825L116.847 188.393C116.896 140.953 116.948 93.5165 117 46.0767Z",
    fill: "#7075E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.402 20.6375C182.685 29.3578 199.434 37.9981 213.456 46.0984C213.508 74.9195 213.563 103.744 213.612 132.568C199.358 140.806 169.402 158.078 169.402 158.078L169.402 20.6375Z",
    fill: "#04B494"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.267 51.3332L288.45 89.3916L222.282 127.625C222.282 102.194 222.267 76.7637 222.267 51.3332Z",
    fill: "#01FBB3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.748 309.851L42.3401 241.506L59.7962 231.481C59.7962 231.481 127.209 270.606 160.748 290.169V309.851Z",
    fill: "#E04A50"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.735 280.251L68.3308 226.328C68.3308 226.328 97.9924 209.161 112.55 200.755C112.55 200.755 145.061 219.818 160.747 228.981L160.735 280.251Z",
    fill: "#7075E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.747 219.079L121.177 195.958C121.177 195.958 147.711 180.474 160.747 172.952V219.079Z",
    fill: "#7075E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.402 172.881C188.909 183.912 225.045 205.125 225.045 205.125L169.402 301.32V172.881Z",
    fill: "#19202E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.029 305.61L232.669 209.385C251.149 220.048 288.352 241.527 288.352 241.527C288.352 241.527 177.256 305.531 177.029 305.61Z",
    fill: "#5980E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M292.6 234.072C274.11 223.418 237.119 201.828 237.119 201.828C237.119 201.828 274.101 137.469 292.6 105.428C292.765 151.018 292.707 189.853 292.6 234.072Z",
    fill: "#19202E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWxPuzzleusdnTci);
export default __webpack_public_path__ + "static/media/wxPUZZLEUSDN_TCI.4cf7eb070525ef36c12d2527a9a9386c.svg";
export { ForwardRef as ReactComponent };